const doc = [({"en":({"js":({"contacts":({"select":({"choose_contact":"Choose contact"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;